import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import RVContext from "../../RVContext";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { CurrencyUtil, LocaleUtil, StringUtil } from "@eres/core";
import { Property, RVProperty } from "../../api/Property";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { RVPropertyType, RVSubmitResponse } from "../../api/entities";
import { RVLookup, RVLookupX } from "../../api/api";
import { getAppServices } from "@10x/coreapp";
import TermsData from "@my-dld/assets/json/rv_terms";
import FeeData from "@my-dld/assets/json/rv_fees";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import { JQModal } from "@my-dld/components/Popup/Utils";
import Popup from "@my-dld/components/Popup/Popup";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { submitRVRequest } from "../../RVUtils";
import RVSubmitted from "./RVSubmitted";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";

interface Props extends RoutedViewProps {
}

interface SD {
	label: LocaleValue;
	value: LocaleValue;
}

interface State {
	count: number;
	property: Property;
	pType: LocaleValue;
	extra: SD[];
	reason: RVLookupX | RVLookup;
	comment: string;
	termsAccepted: boolean;
	propertyType: RVPropertyType;
	feeData: any[];
	showTerms: boolean;
	rv?: RVSubmitResponse;
}

class RVSummary extends Component<Props, State> {
	static contextType = RVContext;
	context!: React.ContextType<typeof RVContext>;

	constructor( props: Props ) {
		super( props );
		const store = getAppServices().storeService.getStore();
		let rv = store.getState().RValuation;
		let property: Property | undefined = ( rv.properties && rv.properties.length > 0 ) ? rv.properties[ 0 ] : undefined;
		const oData: RVProperty = property ? {
			...property!.rvData!.oData,
			...property.rvData!.data,
		} as RVProperty : {} as RVProperty;
		const extra: SD[] = [];
		if ( property ) {
			switch ( property.PropertyTypeId ) {
				case RVPropertyType.UNIT:
					extra.push( {
						label: LVStrings.building_name,
						value: {
							en: oData.BuildingNameEn,
							ar: oData.BuildingNameAr,
						},
					} );
				// tslint:disable-next-line:no-switch-case-fall-through
				case RVPropertyType.VILLA:
				case RVPropertyType.BUILDING:
					let lm = oData.LandNo;
					if ( oData.LandSubNo
						&& !StringUtil.isEmptyStringOrNull( oData.LandSubNo )
						&& "0" !== oData.LandSubNo )
						lm = lm + "-" + oData.LandSubNo;
					extra.push( {
						label: LVStrings.land_no,
						value: {
							en: lm,
						},
					} );
				// tslint:disable-next-line:no-switch-case-fall-through
				case RVPropertyType.LAND:
					extra.push( {
						label: LVStrings.area,
						value: {
							en: oData.AreaNameEn,
							ar: oData.AreaNameEn,
						},
					} );
					break;
			}
		}
		const data = FeeData.filter( f => {
			return f.propertyTypes.indexOf( oData.PropertyTypeId ) !== -1;
		} );
		this.state = {
			termsAccepted: false,
			count: rv.properties ? rv.properties.length : 0,
			property: property!,
			extra: extra,
			reason: rv.reason!,
			comment: rv.comment!,
			propertyType: oData.PropertyTypeId,
			pType: {
				en: oData.PropertyTypeNameEn,
				ar: oData.PropertyTypeNameAr,
			},
			feeData: data,
			showTerms: false,
		};
	}

	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { reason, comment, feeData } = this.state;
		const r = LocaleUtil.getLocalValue( reason );
		const c = comment && !StringUtil.isEmptyStringOrNull( comment ) ? comment : undefined;
		return <React.Fragment>
			<div className="section-title"><h5>{ Strings.properties + " " + Strings.summary }</h5></div>
			<div className="flex-grid">
				<KVRender label={ Strings.total_properties } value={ this.state.count + "" }/>
				<KVRender label={ Strings.property_type } value={ LocaleUtil.getLocalValue( this.state.pType ) }/>
				{ this.state.extra && this.state.extra.map(
					( value, index ) => <KVRender
						key={ index }
						label={ LocaleUtil.getLocalValue( value.label ) }
						value={ LocaleUtil.getLocalValue( value.value ) }/>,
				) }
			</div>
			<div className="section-title"><h5>{ Strings.reason_for_valuation }</h5></div>
			<div className="flex-grid">
				<KVRender label={ Strings.reason } value={ r }/>
				{
					c && <KVRender label={ Strings.comments } value={ c }/>
				}
			</div>

			<ListDataView
				items={ feeData }
				title={ Strings.proposed_fee_structure }
				renderListHeader={ () => {
					return <RenderHeader/>;
				} }
				renderListItem={ ( item: any, index: number ) => {
					return <RenderListItem
						key={ "" + index }
						item={ item } ix={ index }/>;
				} }/>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" id="IAgreeOwner"
                    checked={this.state.termsAccepted}
                    onChange={event => {
                        this.setState({
                            termsAccepted: event.target.checked
                        });
                    }} />
                <label className="form-check-label" htmlFor="IAgreeOwner">
                    {Strings.i_agree_to}
					&nbsp;<a
                        onClick={this.showAgreement}
                        className="link-unerline">{Strings.terms_and_conditions}</a>
                </label>
            </div>
			<Popup
				id={ "agreement" }
				showIcon={ false }
				title={ Strings.terms_and_conditions }>
				<React.Fragment>
					<ul className="rv-terms-conditions">
						{ TermsData.map( ( value, index ) => {
							return <li key={ index }>{ LocaleUtil.getLocalValue( value ) }</li>;
						} ) }
					</ul>
				</React.Fragment>
			</Popup>
			<div className="enoc-add-buyer">
				<button
					className="btn btn_1 btn_style1 btn-sm" data-bs-target="#completedProjectsModal"
					onClick={ this.onProceed }
					data-bs-toggle="modal" type="button">
					{ Strings.submit }
				</button>
			</div>
			{
				this.state.rv && <RVSubmitted
					rv={ this.state.rv }
					onDismiss={ this.onSuccessDismiss }/>
			}
		</React.Fragment>;
	}

	showAgreement = ( e: React.MouseEvent ) => {
		e.preventDefault();
		JQModal( "agreement" ).show();
	};

	onProceed = () => {
		showLoading();
		submitRVRequest().then( rv => {
			hideLoading();
			if ( rv.IsSuccess ) {
				this.setState( { rv: rv }, () => {
					JQModal( "RVSuccessPopup" ).show();
				} );
			} else {
				throw Strings.system_error + rv.Message;
			}
		} ).catch( reason => {
			hideLoading();
			if ( reason && reason.type && reason.type === "ValidationError" ) {
				showMessage( reason.message );
			} else {
				showMessage( reason.toString() );
			}
		} );
	};

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: true,
				lengthChange: false
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};

	private onSuccessDismiss = () => {
		JQModal( "RVSuccessPopup" ).hide();
		replaceNavigate( "/mydld" );
	};
}

function KVRender( props: { label: string, value: string } ) {
	const { label, value } = props;
	return <div>
		<span>{ LocaleUtil.getLocalValue( label ) }</span>
		<span>{ value }</span>
	</div>;
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.type_of_valuation }</th>
		<th>{ Strings.fees + " (" + Strings.in_aed + ")" }</th>
	</tr>;
}

function RenderListItem( props: { item: any, ix: number } ) {
	const { item, ix } = props;
	return <tr role={ "row" } className={ ix % 2 === 0 ? "odd" : "even" } key={ "fee_" + ix }>
		<td>{ LocaleUtil.getLocalValue( item ) }</td>
		<td>{ CurrencyUtil.toFormattedCurrency( item.value ) }</td>
	</tr>;
}

export default RVSummary;
